import { connect } from 'react-redux';
import { injectIntl } from "react-intl";
import BasicDetailsSectionComponent from './BasicDetailsSection';
import Claimviewheader from './Claimviewheader';
import { createSelector } from 'reselect';
import { selectHasCMSAccess, selectIsSuperAdmin,selectHasCMSClaimAnalysisAccess } from '../../../../store/selectors/session';
import { selectRecoveredAmountFlag } from '../../../../store/selectors/settings';
import { selectClaimAllDetails, selectClaimHistory } from '../../../../store/selectors/claimAnalysis';
import { bindActionCreators } from 'redux';
import { getConsolidatedClaims, processBulkOnDemand, setAdjustment, setClaimServiceAdjustments, resetConsolidatedClaimsView, setClaimCommentsConfirmationDialog, getClaimStatuses } from '../../../../store/actions/claimAnalysis';
import { getModelConsolidatedClaims, resetModelConsolidatedClaimsView } from '../../../../store/actions/modeling';
import { setMulti } from '../../../../store/actions/pages';
import { selectHasPlanIdMappingAccess } from '../../../../store/selectors/session';

export const selectModelAllDetails = (state) => state.modeling.modelAllDetails;
const selectConsolidatedData = (state) => state.claimAnalysis.consolidatedClaimsData;
const selectModelConsolidatedData = (state) => state.modeling.consolidatedClaims;

const selectHasJSONViewAccess = createSelector(
    selectHasCMSAccess,
    selectIsSuperAdmin,
    selectHasCMSClaimAnalysisAccess,
    (hasCMSAccess, isSuperAdmin,canAccessClaimAnalysis) => {
        return hasCMSAccess || isSuperAdmin || canAccessClaimAnalysis;
    }
);

const selectTraceSections = createSelector(selectClaimAllDetails,
    (claimAnalysis) => {
        const trace = JSON.parse(claimAnalysis?.claimAnalysisTraceLog ?? null);
        return trace ? trace?.Sections : [];
    }
);

const selectChargeLevelTraceSections = createSelector(selectClaimAllDetails,
    (claimAnalysis) => {
        const trace = JSON.parse(claimAnalysis?.claimAnalysisChargeLevelTraceLog ?? null);
        if (trace && trace.Sections) {
            return trace.Sections.sort((a, b) => {
                const aIndex = parseInt(a.Name.split('-')[1], 10);
                const bIndex = parseInt(b.Name.split('-')[1], 10);
                return aIndex - bIndex;
            });
        }
        return [];
    }
);

const selectDRGCode = createSelector(
    (state) => state.claimAnalysis.detail,
    (detail) => {

        const drg=(detail as any || [])?.reverse()?.find((item)=>item?.drg)?.drg || ''
        return drg
    }
);

const selectDRGDescription = createSelector(
    (state) => state.claimAnalysis.detail,
    (detail) => {
         const drg=(detail as any || [])?.reverse()?.find((item)=>item?.drgDescription)?.drgDescription || ''
         return drg
    }
);

const selectPrincipalPx = createSelector(
    (state) => state.claimAnalysis.detail,
    (detail: any) => {
        let pxObj = detail.find(x=> x.principalPx !== null && x.principalPx !== '');
        return pxObj !== null ? pxObj?.principalPx : ''
    }
);

const selectPrincipalPxDescription = createSelector(
    (state) => state.claimAnalysis.detail,
    (detail: any) => {
        let pxObj = detail.find(x=> x.principalPx !== null && x.principalPx !== '');
        return pxObj !== null ? pxObj?.principalPxDescription : ''
    }
);

const selectPrincipalPxDate = createSelector(
    (state) => state.claimAnalysis.detail,
    (detail: any) => {
        let pxObj = detail.find(x=> x.principalPxDate !== null && x.principalPxDate !== '');
        return pxObj !== null ? pxObj?.principalPxDate : ''
    }
);

const selectPrincipalDx = createSelector(
    (state) => state.claimAnalysis.detail,
    (detail) => {
        return detail.length > 0 ? detail[0]?.principalDx : ''
    }
);

const selectPrincipalDxDescription = createSelector(
    (state) => state.claimAnalysis.detail,
    (detail) => {
        return detail.length > 0 ? detail[0]?.principalDxDescription : ''
    }
);

const selectModelPrincipalDx = createSelector(
    (state) => state.modeling.analysisResults,
    (results) => {
        return results.length > 0 ? results[0]?.Principaldx : ''
    }
);

const selectModelDRG = createSelector(
    (state) => state.modeling.analysisResults,
    (results) => {
        const drg=(results as any || [])?.reverse()?.find((item)=>item?.Drg)?.Drg || ''
        return drg
    }
);

const selectConsolidatedClaims = createSelector(
    selectClaimAllDetails,
    selectConsolidatedData,
    (state) => state.claimAnalysis.getClaimAllDetails.pending,
    (claimDetails, consolidatedData, claimDetailsPending) => {
        if(claimDetails && consolidatedData && !claimDetailsPending) {
            return consolidatedData?.length === 1 &&
            consolidatedData[0] === claimDetails?.claimnumber
                ? []
                : consolidatedData?.filter(x=> x !== claimDetails?.claimnumber)?.sort((a, b) => a.localeCompare(b, 'en', { numeric: true }))?.reverse();
        }
        else {
            return [];
        }
    }
);

const selectModelConsolidatedClaims = createSelector(
    selectModelAllDetails,
    selectModelConsolidatedData,
    (state) => state.modeling.getModelAllDetails.pending,
    (claimDetails, consolidatedData, claimDetailsPending) => {
        if(claimDetails && consolidatedData && !claimDetailsPending) {
            return consolidatedData?.length === 1 &&
            consolidatedData[0] === claimDetails?.claimnumber
                ? []
                : consolidatedData?.filter(x=> x !== claimDetails?.claimnumber)?.sort((a, b) => a.localeCompare(b, 'en', { numeric: true }))?.reverse();
        }
        else {
            return [];
        }
    }
);

const selectDischargeStatusDescription = createSelector(
    selectClaimAllDetails,
    (state) => state.rules.dischargeStatusCodes ?? [],
    (claimAllDetails, dischargeStatusCodes) => {
        const match = dischargeStatusCodes.find(item => item.code === claimAllDetails?.dischargestatus);
        return match?.description ?? '';
    }
);

const mapState = () => (state, props) => ({
    claimAllDetails: props.isFromModel ? selectModelAllDetails(state) : selectClaimAllDetails(state),
    dischargeStatusDescription: selectDischargeStatusDescription(state),
    hasJSONViewAccess: selectHasJSONViewAccess(state),
    sections: selectTraceSections(state),
    chargeLevelSections: selectChargeLevelTraceSections(state),
    recoveredAmountFlag: selectRecoveredAmountFlag(state, props),
    drg: props.isFromModel ? selectModelDRG(state) : selectDRGCode(state),
    drgDescription: selectDRGDescription(state),
    principalDx: props.isFromModel ? selectModelPrincipalDx(state) : selectPrincipalDx(state),
    principalDxDescription: selectPrincipalDxDescription(state),
    claimHistory: selectClaimHistory(state, props),
    getClaimDetailsPending: props.isFromModel ? state.modeling.getModelAllDetails.pending : state.claimAnalysis.getClaimAllDetails.pending,
    claimBulkOnDemandPending: state.claimAnalysis.processBulkOnDemand.pending,
    comment: state.claimAnalysis.newComment,
    consolidatedClaims: props.isFromModel ? selectModelConsolidatedClaims(state) : selectConsolidatedClaims(state),
    principalPx: selectPrincipalPx(state),
    principalPxDescription: selectPrincipalPxDescription(state),
    principalPxDate: selectPrincipalPxDate(state),
    canAccessPayerMapping: selectHasPlanIdMappingAccess(state)
});

const mapDispatch = (dispatch, props) => ({
    actions: bindActionCreators({
        setAdjustment,
        setClaimServiceAdjustments,
        processBulkOnDemand,
        getConsolidatedClaims,
        getModelConsolidatedClaims,
        resetConsolidatedClaimsView,
        resetModelConsolidatedClaimsView,
        setClaimCommentsConfirmationDialog,
        getClaimStatuses,
        setMulti: obj => setMulti("claim-audits-landing", obj),
    }, dispatch)
});

export const BasicDetailsSection = connect(mapState, mapDispatch)(injectIntl(BasicDetailsSectionComponent));

export const ClaimViewHeader = connect(mapState, mapDispatch)(injectIntl(Claimviewheader));